import React from 'react';
import {Grid} from '@mui/material';
import {useAccountContext} from '../../contexts/AccountContext';
import {Panel} from '../Panel/Panel';
import {themeColors} from '../../theme/Theme';
import {useVulnerabilityOptions} from '../../features/vulnerabilities/useVulnerabilityOptions';
import {ContactVulnerabilitiesTable} from '../../features/vulnerabilities/ContactVulnerabilitiesTable';
import {VulnerabilityModalContact} from '../../features/vulnerabilities/VulnerabilityModal';

/**
 * Account overview "Vulnerabilities" panel (DBO-766) for every proposition:
 * one table per contact, primary first, mirroring Curo's vulnerability table.
 * Each add or edit syncs to Curo at once. SFP reviews additionally capture
 * changes in the review journey, synced on handover. Hidden where the Curo
 * entity is unavailable.
 */
export const AccountVulnerabilities: React.FC = () => {
  const {account, accountId} = useAccountContext();
  const options = useVulnerabilityOptions();

  if (!account || !accountId) {
    return null;
  }
  if (options.loading || !options.isEnabled) {
    return null;
  }
  const contacts: VulnerabilityModalContact[] = [
    account.primaryContact,
    account.secondaryContact,
  ].flatMap((contact) =>
    contact ? [{id: contact.id, simplifiedName: contact.simplifiedName}] : []
  );
  if (contacts.length === 0) {
    return null;
  }

  return (
    <Grid item xs={12}>
      <Panel title="Vulnerabilities" color={themeColors.coral}>
        {contacts.map((contact) => (
          <ContactVulnerabilitiesTable
            key={contact.id}
            accountId={accountId}
            contact={contact}
            options={options}
          />
        ))}
      </Panel>
    </Grid>
  );
};
